import React from "react"
import DodoablesList from 'app/dodoables/list/Index'
import useDodoableCollectionQuery from 'generated/api/dodoables/useDodoableCollectionQuery'
import LoadingScreen from 'app/components/LoadingScreen'

export default () => {
  const { isPending, data: { dodoables } = {} } = useDodoableCollectionQuery({ query: { active: true, freeable: true }})

  if(isPending)
    return <LoadingScreen />

  return <DodoablesList dodoables={ dodoables } />;
};
